import axios from "axios";
import { isNil, isObject } from "lodash";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { ProjectDrawingActionTypes } from "./ProjectDrawing.type";

export function* fetchAllProjectDrawings(action?: any): any {
  try {
    let queryData = action.payload;
    const query =
      !isNil(queryData) && isObject(queryData)
        ? "?" +
          Object.keys(action.payload)
            .map((key) => `${key}=${queryData[key]}`)
            .join("&&")
        : "";

    const response = yield axios.get(`${API_BASE_URI}/project-drawing${query}`);

    yield put({
      type: ProjectDrawingActionTypes.FETCH_ALL_PROJECT_DRAWING_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ProjectDrawingActionTypes.FETCH_ALL_PROJECT_DRAWING_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllProjectDrawings() {
  yield takeLatest(ProjectDrawingActionTypes.FETCH_ALL_PROJECT_DRAWING, fetchAllProjectDrawings);
}
